// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3qhEo","footer":"Form_footer__1Vn1K"};